module.exports = __webpack_public_path__ + "static/media/bg-2.aab2115c.png";